import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Trash2, Loader2 } from "lucide-react";

export function DeleteAllStudentsButton({ students, filtered, onDone }) {
  const [open, setOpen] = useState(false);
  const [txt, setTxt] = useState("");
  const [busy, setBusy] = useState(false);
  async function go() {
    setBusy(true);
    try {
      const { data } = await api.post("/students/delete-bulk", { ids: students.map((s) => s.id) });
      toast.success(`${data.deleted} students deleted`); setOpen(false); setTxt(""); onDone();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  }
  return (
    <>
      <Button data-testid="delete-all-students-btn" variant="outline" disabled={!students.length} onClick={() => setOpen(true)} className="h-11 px-4 text-rose-600 border-rose-200 hover:bg-rose-50">
        <Trash2 size={16} className="mr-2" /> Delete all ({students.length})
      </Button>
      <Dialog open={open} onOpenChange={(v) => { setOpen(v); if (!v) setTxt(""); }}>
        <DialogContent>
          <DialogHeader><DialogTitle className="font-display text-rose-700">Delete {students.length} students?</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600">This moves {filtered ? "every student shown with the current filters" : "every student in the list"}, with their attendance, daily activity, progress reports and fee invoices, to the Recycle bin. You can restore them for 30 days.</p>
          <p className="text-sm text-slate-700 mt-2">Type <span className="font-bold">DELETE</span> to confirm.</p>
          <Input data-testid="delete-all-confirm-input" value={txt} onChange={(e) => setTxt(e.target.value)} placeholder="DELETE" />
          <Button data-testid="delete-all-confirm-btn" disabled={txt !== "DELETE" || busy} onClick={go} className="bg-rose-600 hover:bg-rose-700 w-full mt-2">
            {busy && <Loader2 size={14} className="animate-spin mr-1" />}Delete {students.length} students</Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
